__turbopack_context__.v({
  "header": "BoardSectionItemBR24In100Seconds-module-scss-module__YHn7ta__header",
  "title": "BoardSectionItemBR24In100Seconds-module-scss-module__YHn7ta__title",
  "wrapper": "BoardSectionItemBR24In100Seconds-module-scss-module__YHn7ta__wrapper",
});
